import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    Input,
    ViewEncapsulation,
    ChangeDetectorRef
} from '@angular/core';

@Component({
    selector: `
        button[fcp-button], button[fcp-filled-button], button[fcp-outlined-button], button[fcp-transparent-button],
        a[fcp-button], a[fcp-filled-button], a[fcp-outlined-button], a[fcp-transparent-button]
    `,
    host: {
        '[attr.disabled]': 'disabled || null',
        '[class.fcp-button--disabled]': '!!disabled',
        '[class.fcp-button-outlined]': "variant === 'outlined'",
        '[class.fcp-button-filled]': "variant === 'filled'",
        '[class.fcp-button-transparent]': "variant === 'transparent'",
        '[class.fcp-button-prominent]': "color === 'default' || color === 'prominent'",
        '[class.fcp-button-subtle]': "color === 'subtle'",
        '[class.fcp-button-critical]': "color === 'critical'",
        '[class.fcp-text-button-s]': "size === 'small'",
        '[class.fcp-text-button-m]': "size === 'medium'",
        '[class.fcp-text-button-l]': "size === 'large'",
        '[class.fcp-button--icon-only]': 'iconOnly',
        class: 'fcp-button'
    },
    templateUrl: './fcp-button.component.html',
    styleUrls: ['./fcp-button.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FcpButtonComponent implements AfterViewInit {
    @Input() disabled: boolean | 'disabled';
    @Input() color: FcpButtonColors = FcpButtonColors.Default;
    @Input() size: FcpButtonSizes = FcpButtonSizes.Medium;
    @Input() iconOnly = false;

    public variant: FcpButtonVariants = this.getVariant();

    @HostBinding('class.fcp-button--link') get isAnchorElement() {
        return this.getHostElement()?.tagName.toLowerCase() === 'a';
    }

    constructor(
        private elementRef: ElementRef,
        private cdr: ChangeDetectorRef
    ) {}

    ngAfterViewInit() {
        this.variant = this.getVariant();
    }

    private getHostElement() {
        return this.elementRef.nativeElement;
    }

    private hasHostAttributes(...attributes: string[]) {
        return attributes.some((attribute) => this.getHostElement().hasAttribute(attribute));
    }

    private getVariant(): FcpButtonVariants {
        let variant: FcpButtonVariants;

        if (this.hasHostAttributes('fcp-outlined-button')) {
            variant = FcpButtonVariants.Outlined;
        } else if (this.hasHostAttributes('fcp-transparent-button')) {
            variant = FcpButtonVariants.Transparent;
        } else {
            variant = FcpButtonVariants.Filled;
        }

        this.cdr.markForCheck();
        return variant;
    }
}

export enum FcpButtonColors {
    Default = 'default',
    Prominent = 'prominent',
    Subtle = 'subtle',
    Critical = 'critical'
}

export enum FcpButtonVariants {
    Outlined = 'outlined',
    Filled = 'filled',
    Transparent = 'transparent'
}

export enum FcpButtonSizes {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}
